/**
 * LOP - Ajuste de tamaño de fuente para "Precio sin imp país" en mobile
 * Detecta cuando el contenido se desborda y reduce el tamaño de fuente en 1px
 * Incluye carruseles de lanzamientos (collection-tabs) sin flickering
 * Usa IntersectionObserver para detectar elementos cuando se vuelven visibles
 */
(function() {
  'use strict';
  
  let observer = null;
  
  // Solo ejecutar en mobile
  function isMobile() {
    return window.innerWidth <= 768;
  }
  
  // Ajustar font-size de un elemento específico
  function adjustSingleElement(container) {
    if (!isMobile()) return;
    
    // Si ya fue procesado, saltar
    if (container.dataset.fontAdjustedPermanent === 'true') return;
    
    const label = container.querySelector('.LOP-product-price-without-taxes-label--mobile');
    const value = container.querySelector('.LOP-product-price-without-taxes-value');
    
    if (!label || !value) return;
    
    // Esperar un frame para asegurar que el layout esté calculado
    requestAnimationFrame(function() {
      const containerWidth = container.clientWidth;
      const scrollWidth = container.scrollWidth;
      
      // Si el contenido se desborda, reducir el tamaño de fuente
      if (scrollWidth > containerWidth + 2) {
        label.style.fontSize = '13px';
        value.style.fontSize = '13px';
      }
      // Marcar como procesado PERMANENTEMENTE (evita flickering)
      container.dataset.fontAdjustedPermanent = 'true';
    });
  }
  
  // Ajustar todos los elementos visibles
  function adjustPriceWithoutTaxesFontSize() {
    if (!isMobile()) return;
    
    const containers = document.querySelectorAll('.LOP-product-price-without-taxes');
    
    containers.forEach(function(container) {
      // Solo procesar si tiene dimensiones (es visible)
      if (container.offsetWidth > 0) {
        adjustSingleElement(container);
      }
    });
  }
  
  function resetFontSizes() {
    document.querySelectorAll('.LOP-product-price-without-taxes').forEach(function(container) {
      container.dataset.fontAdjustedPermanent = 'false';
      const label = container.querySelector('.LOP-product-price-without-taxes-label--mobile');
      const value = container.querySelector('.LOP-product-price-without-taxes-value');
      if (label) label.style.fontSize = '';
      if (value) value.style.fontSize = '';
    });
  }
  
  // Configurar IntersectionObserver para detectar elementos que se vuelven visibles
  function setupIntersectionObserver() {
    if (!isMobile()) return;
    if (observer) return; // Ya configurado
    
    observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          const container = entry.target;
          // Pequeño delay para asegurar que el layout esté estable
          setTimeout(function() {
            adjustSingleElement(container);
          }, 50);
          // Dejar de observar este elemento (ya fue procesado)
          observer.unobserve(container);
        }
      });
    }, {
      root: null, // viewport
      rootMargin: '100px', // detectar un poco antes de que sea visible
      threshold: 0.1
    });
    
    // Observar todos los contenedores de precio
    document.querySelectorAll('.LOP-product-price-without-taxes').forEach(function(container) {
      if (container.dataset.fontAdjustedPermanent !== 'true') {
        observer.observe(container);
      }
    });
  }
  
  // Volver a observar elementos después de reset
  function reobserveElements() {
    if (!observer) {
      setupIntersectionObserver();
      return;
    }
    
    document.querySelectorAll('.LOP-product-price-without-taxes').forEach(function(container) {
      if (container.dataset.fontAdjustedPermanent !== 'true') {
        observer.observe(container);
      }
    });
  }
  
  function init() {
    // Ejecutar ajuste inicial para elementos ya visibles
    setTimeout(adjustPriceWithoutTaxesFontSize, 300);
    
    // Configurar observer para elementos que se vuelvan visibles después
    setTimeout(setupIntersectionObserver, 400);
    
    // Ejecutar de nuevo después de que las imágenes se carguen
    window.addEventListener('load', function() {
      setTimeout(adjustPriceWithoutTaxesFontSize, 500);
      setTimeout(reobserveElements, 600);
    });
  }
  
  // Ejecutar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // También ejecutar cuando se redimensione la ventana
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      if (isMobile()) {
        resetFontSizes();
        setTimeout(adjustPriceWithoutTaxesFontSize, 200);
        setTimeout(reobserveElements, 300);
      } else {
        resetFontSizes();
        // Desconectar observer si no es mobile
        if (observer) {
          observer.disconnect();
          observer = null;
        }
      }
    }, 250);
  });
  
  // Exponer función para uso externo
  window.LOP_adjustPriceWithoutTaxesFontSize = adjustPriceWithoutTaxesFontSize;
  
})();

